import { ProductModel } from './../models/product.model';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnChanges
} from '@angular/core';
import {ImageUploadImageSetModel} from '../../image-admin/image-models/image-upload-image-set.model';
import {ProdcutImageUtil} from '../../lib/product-image-util';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-product-details-header',
  template: `
  <div class="container-fluid row" style="width:100%;">
    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" style="margin-top: 2%; margin-bottom: 2%;" >
      <h1 [innerHTML]="this.model.title" class="headerTitle"></h1>
      <div [innerHTML]="this.model.type" class="headerType">
      </div>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" style="margin-top: 2%; margin-bottom: 2%;">
      <picture class="product-img-elem">
        <source [srcset]="this.hiresproductImage" media="(min-width: 1920px)" />
        <source [srcset]="this.desklargeproductImage" media="(max-width: 1919px) and (min-width: 1280x)" />
        <source [srcset]="this.desksmallproductImage" media="(max-width: 1279px) and (min-width: 1024px)" />
        <source [srcset]="this.tabletproductImage" media="(max-width: 1023px) and (min-width: 769px)" />
        <img [src]="this.phoneproductImage" alt="" />
      </picture>
    </div>
  </div>`,
  styles: [
    `
      .headerTitle {
        color: #a50034;
        font-family: 'LGEIBold';
        font-size: 40px;
        text-align: left;
      }
      
      .headerType {
         color: #4a4a4a;
         font-family: 'LGEIRegular';
         font-size: 28px;
         text-align: left;
         margin-bottom: 5px;
       }

      .downloadLink {
        color: #a50034;
        font-family: 'LGEIRegular';
        font-size: 20.1px;
        text-align: left;
        margin-bottom: 5px;
      }

      .headerDescription {
        color: #4a4a4a;
        font-family: 'LGEIRegular';
        font-size: 20.1px;
        font-weight: 300;
        text-align: left;
      }

      .headerImage {
        display: block;
        vertical-align: middle;
        height: 264px;
        margin: auto;
      }

      .product-img-elem {
        margin: auto;
        display: block;
        max-height: 280px;
        text-align: center;
      }

      @media only screen and (min-width: 769px) {
        .row {
          display: flex !important;
        }
      }
    `
  ]
})
export class ProductDetailsHeaderComponent implements OnChanges {
  @Input() model: ProductModel;
  @Input() iscommercial: string;
  @Input() class: string;
  currentImageSet: ImageUploadImageSetModel = new ImageUploadImageSetModel();
  hiresproductImage = 'https://images.lghvac.com/static/thumbnail-default_2.jpg';
  desklargeproductImage = 'https://images.lghvac.com/static/thumbnail-default_2.jpg';
  desksmallproductImage = 'https://images.lghvac.com/static/thumbnail-default_2.jpg';
  tabletproductImage = 'https://images.lghvac.com/static/thumbnail-default_2.jpg';
  phoneproductImage = 'https://images.lghvac.com/static/thumbnail-default_2.jpg';
  imageUtil = new ProdcutImageUtil();
  archiveUrl: string;


  ngOnChanges() {
    // choose selected image based on line and class
    const className = this.imageUtil.translateClassName(this.iscommercial, this.class);

    const line = this.iscommercial == 'true' ? 'Commercial' : 'Residential-Light Commercial';
    const clas = className ? className.replace('/', '-').replace('%20', ' ') : null;
    this.archiveUrl = `${environment.archivePath}/resource_archive_${line}_${clas}_${this.model.id}.zip`;

    if (this.model.images && this.model.images[0]) {      
      this.imageUtil.mapImages(className, this.iscommercial, this.model.images, this.currentImageSet);
      this.hiresproductImage = this.currentImageSet && this.currentImageSet.highresimage.url ? this.currentImageSet.highresimage.url : 'https://images.lghvac.com/static/thumbnail-default_2.jpg';
      this.desklargeproductImage = this.currentImageSet && this.currentImageSet.desktoplargeimage.url ? this.currentImageSet.desktoplargeimage.url : 'https://images.lghvac.com/static/thumbnail-default_2.jpg';
      this.desksmallproductImage = this.currentImageSet && this.currentImageSet.desktopsmallimage.url ? this.currentImageSet.desktopsmallimage.url : 'https://images.lghvac.com/static/thumbnail-default_2.jpg';
      this.tabletproductImage = this.currentImageSet && this.currentImageSet.tabletimage.url ? this.currentImageSet.tabletimage.url : 'https://images.lghvac.com/static/thumbnail-default_2.jpg';
      this.phoneproductImage = this.currentImageSet && this.currentImageSet.phoneimage.url ? this.currentImageSet.phoneimage.url : 'https://images.lghvac.com/static/thumbnail-default_2.jpg';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/product-category/components/product-details-header.component.ts